module.exports = __webpack_public_path__ + "static/media/document-duplicate.c268ff14.svg";